module.exports = __webpack_public_path__ + "img/JeanPierreRodriques_140x140_rund.ce0326bb.jpg";